import { render, staticRenderFns } from "./RFooter.vue?vue&type=template&id=d080f5be&scoped=true&"
import script from "./RFooter.vue?vue&type=script&lang=js&"
export * from "./RFooter.vue?vue&type=script&lang=js&"
import style0 from "./RFooter.vue?vue&type=style&index=0&id=d080f5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080f5be",
  null
  
)

export default component.exports